export default "__VITE_ASSET__Cu5m8fJh__"